// extracted by mini-css-extract-plugin
export default {"page":"theme_page__bDEew","modal":"theme_modal__sPiNm"};